import React, { useMemo } from "react"
import parseVCard from "../utils/parseVCard"
import { Avatar } from "@material-ui/core"
import { Person } from "@material-ui/icons"

/**
 * @typedef {Object} ParsedVCard
 * @property {string} name
 * @property {string} phone
 * @property {string} [photo]
 */

/**
 * @typedef {Object} QuotedContactsProps
 * @property {import("../MessageItem").Message} message
 * @property {import("@material-ui/styles").ClassNameMap} classes
 */

const QuotedContacts = React.memo(
  /**
   * @param {QuotedContactsProps} props
   */
  ({ message, classes }) => {
    /** @type {ParsedVCard[]} */
    const contacts = useMemo(() => {
      const vcards = message.body.split("||")
      return vcards.map(parseVCard)
    }, [message.body])

    if (contacts.length <= 1) return null

    return (
      <div className={`${message.fromMe ? classes.messageRight : classes.messageLeft}`} style={{ width: 300 }}>
        <div style={{ display: "flex", alignItems: "center", gap: 8, paddingBottom: 5 }}>
          {contacts.slice(0, 3).map((contact, index) => {
            if (contact.photo) {
              return (
                <img
                  key={`contact-photo-${index}`}
                  src={`data:image/jpeg;base64,${contact.photo}`}
                  alt="Contact"
                  style={{
                    width: 40,
                    height: 40,
                    borderRadius: "50%",
                    objectFit: "cover",
                  }}
                />
              )
            }

            const firstChar = contact.name?.charAt(0)
            const isPhone = firstChar === "+" || !isNaN(firstChar)

            return (
              <Avatar key={`contact-avatar-${index}`} className={classes.avatar}>
                {isPhone ? <Person /> : firstChar}
              </Avatar>
            )
          })}

          {contacts.length > 3 && <Avatar className={classes.avatar}>+{contacts.length - 3}</Avatar>}
        </div>
      </div>
    )
  },
)

QuotedContacts.displayName = "QuotedContacts"

export default QuotedContacts
